import { Component, OnInit } from '@angular/core';
import { BuildingBlock, BuildingBlockControlBaseComponent } from '../building-block.types';

@BuildingBlock('field-group-card')
@Component({
  selector: 'ecp-field-group-card',
  templateUrl: './field-group-card.component.html',
  standalone: false
})
export class FieldGroupCardComponent extends BuildingBlockControlBaseComponent implements OnInit {
  public ngOnInit(): void {}
}
